import lazyJs from '../functions/lazyJs';

const INIT_CLASS = 'luigisbox-init';
const LUGI_URL = '//cdn.luigisbox.com/autocomplete.js';
const OPTIONS = {
  Layout: 'heromobile',
  TrackerId: '',
  Types: [
    {'type': 'item', 'context': '', 'placement': '', 'name': '', 'size': 7, 'attributes': [], 'recommend': {'size': '7'}, 'defaultFilters': {availability: 1}, 'position': 1},
    {'type': 'category', 'context': '', 'placement': '', 'name': '', 'size': 5, 'attributes': [], 'recommend': {'size': '4'}, 'defaultFilters': null, 'position': 3},
    {'type': 'brand', 'context': '', 'placement': '', 'name': '', 'size': 4, 'attributes': [], 'recommend': {'size': '4'}, 'defaultFilters': null, 'position': 4}
  ],
  Locale: '',
  Translations: {},
  ShowAllPlacement: 'others',
  Align: 'center',
  ShowBranding: false,
  TypingSuggestions: false,
  TypingSuggestionsTimeout: 0,
  ShowHeroProduct: true,
  AutoReposition: false,
  GridPosition: 'right',
  BeforeRender: function(query, results) {
    if (window.dataLayer) {
      window.dataLayer.push({'event': 'search', 'search_term': query});
    }

    return results;
  }
};

let LBInitAutocomplete = function(settings) {
  window.AutoComplete(settings, '#ProductSearchForm #searchText');
};

export function lugisbox() {
  if (document.body.classList.contains(INIT_CLASS)) {
    return;
  }

  document.body.classList.add(INIT_CLASS);

  if (window.lugisboxConfig) {
    let settings = Object.assign({}, OPTIONS);
    settings.TrackerId = window.lugisboxConfig.TrackerId;
    settings.Locale = window.lugisboxConfig.Locale;
    settings.Translations = window.lugisboxConfig.Translations;

    lazyJs(LUGI_URL, 'AutoComplete', function() {
      LBInitAutocomplete(settings);
    });
  }
}
